module.exports = __webpack_public_path__ + "img/Listening State.67df8e51.png";